module.exports = __webpack_public_path__ + "static/media/mobile.45a8ada9.svg";